import React from 'react';
import intl from 'react-intl-universal';
import styles from './index.less';
import closeIcon from '../../assets/closeIcon.png';
import radio from '../../assets/radio.png';
import radioActive from '../../assets/radioActive.png';

interface ChannelTypeProps {
  showChannelType: boolean;
  setShowChannelType: (showChannelType: boolean) => void;
  selectedChannelTypeKey: string;
  setSelectedChannelType: (selectedChannelType: string) => void;
  channelList: any[];
  setSelectedChannelTypeKey: (selectedChannelTypeKey: string) => void;
}
function ChannelType({ showChannelType, setShowChannelType, selectedChannelTypeKey, setSelectedChannelType, channelList, setSelectedChannelTypeKey }: ChannelTypeProps) {

  return (
    <div className={styles['channelTypeContainer']} style={{ display: showChannelType ? 'block' : 'none' }}>
      <div className={styles['channelTypeContent']}>
        <div className={styles['channelTypeContentTitle']}>
          <span>{intl.get('qrcode.signIn.channelType')}</span>
          <img src={closeIcon} alt="" className={styles['channelTypeContentCloseIcon']} onClick={() => setShowChannelType(false)} />
        </div>
        {
          channelList.length ? (
            <div className={styles['channelTypeContentList']}>
              {
                channelList.map((item) => {
                  return (
                    <div className={styles['channelTypeContentListItem']} key={item.channelId} onClick={() => {
                      setSelectedChannelType(item.channelName)
                      setSelectedChannelTypeKey(item.channelId)
                    }}>
                      <span>{item.channelName}</span>
                      <img src={selectedChannelTypeKey === item.channelId ? radioActive : radio} alt="" className={styles['channelTypeContentListItemRadio']} />
                    </div>
                  )
                })
              }
            </div>
          ) : <div className={styles['channelTypeContentListNoData']}>
            <span>{intl.get('qrcode.signIn.noResultsFound')}</span>
          </div>
        }
      </div>
    </div>
  )
}

export default ChannelType